module.exports = __webpack_public_path__ + "img/grilled-shrirmp.212773bb.png";